define((require) => {
    "use strict";

    const AnimationController = require("shared/ui/experience/widgets/animations/AnimationController");

    /**
     * The animation controller for zoom in.
     *
     * @class ZoomInAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.OUTRO, // We're scaling to 0.0, hence "outro"

        descriptor() {
            return {
                to: {scale: 0}
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/zoomOut/ZoomOutAnimationController.js